// Formats a float to show the appropriate amount of trailing decimals based on the supplied factor
// This can be useful as floating point limitations sometimes cause weird results (e.g. 255 * 0.01 = 2.5500000000000003)
export default function formatFloat(float, factor) {
   const factorStr = factor.toString()
   if (factorStr.includes('.')) {
      let decimals = factorStr.split('.')[1].length
      return parseFloat(float.toFixed(decimals))
   }
   return float
}